export default __webpack_public_path__ + "static/aed_b.4a7e3106ca81d9ad29957c796759bdb7.svg";